import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
// material
import CloseIcon from '@material-ui/icons/Close';
import {
  Slide,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
} from '@material-ui/core';
//
import ViewDesignOrder from 'src/pages/dashboard/ViewDesignOrder';

const Transition = forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);
 function FullScreenDialogDesignOrder({
  open,
   setOpen,
   projectId:initialProjectId,
   projectName:initialProjectName,
   isEditDesignOrder:initialIsEditDesignOrder,
   setRenderCards,
   renderCards,
   setIsEditDesignOrder:EditDesignOrder
  }) {

  const [dataChanged, setDataChanged] = useState(false); 
// const[jobCostId,setJobCostId]=useState('');

  const headerStepBackRef = useRef(() => false);

const [projectId, setProjectId] = useState(
  localStorage.getItem('designOrderProjectId') || initialProjectId || ''
);
const [projectName, setProjectName] = useState(
  localStorage.getItem('designOrderProjectName') || initialProjectName || ''
);
const [isEditDesignOrder, setIsEditDesignOrder] = useState(
  localStorage.getItem('isEditDesignOrder') === 'true' || initialIsEditDesignOrder || false
);

  const handleExitDesignOrderEditMode = useCallback(() => {
    setIsEditDesignOrder(false);
    localStorage.setItem('isEditDesignOrder', 'false');
  }, []);

useEffect(() => {
  if (open) {
    localStorage.setItem('designOrderProjectId', projectId);
    localStorage.setItem('designOrderProjectName', projectName);
    localStorage.setItem('isEditDesignOrder', isEditDesignOrder);
    localStorage.setItem('designOrderOpenProductionPopup', 'true');
  } else {
    // localStorage.removeItem('designOrderProjectId');
    // localStorage.removeItem('designOrderProjectName');
    // localStorage.removeItem('isEditDesignOrder');
    localStorage.removeItem('designOrderOpenProductionPopup',);
  }
}, [open, projectId, projectName, isEditDesignOrder]);
useEffect(() => {
  if (open) {
    setProjectId(localStorage.getItem('designOrderProjectId') || initialProjectId || '');
    setProjectName(localStorage.getItem('designOrderProjectName') || initialProjectName || '');
    setIsEditDesignOrder(localStorage.getItem('isEditDesignOrder') === 'true' || initialIsEditDesignOrder || false);
  }
}, [open]);
  const handleClose = () => {
    setProjectId("");
    setProjectName("");
    setIsEditDesignOrder("");
    setOpen(false);
    localStorage.removeItem('designOrderProjectId');
    localStorage.removeItem('designOrderProjectName');
    localStorage.removeItem('isEditDesignOrder');
    localStorage.removeItem('designOrderOpenProductionPopup',);
    // if (dataChanged) {
      setRenderCards(!renderCards);
      setDataChanged(false); // Reset the flag after triggering the re-render
    // }
  };

  const handleHeaderClose = () => {
    const tryStep = headerStepBackRef.current;
    if (typeof tryStep === 'function' && tryStep()) return;
    handleClose();
  };

  const handleDataChange = () => {
    setDataChanged(true); 
    console.log('Entered=handleDataChange')
  };
  return (
    <>
      <Dialog fullScreen open={open} onClose={handleHeaderClose} TransitionComponent={Transition}>
        <AppBar position="relative" mb={3}>
          <Toolbar>
            <Typography variant="h6" sx={{ flex: 1, ml: 2 }}>
              {projectName}
            </Typography>
              <CloseIcon onClick={handleHeaderClose} sx={{fontSize:'2.7rem',cursor:'pointer'}}/>
          </Toolbar>
        </AppBar>
        <MemoizedViewDesignOrder
          popupOn={true}
          setRenderCards={setRenderCards}
          idOfProject={projectId}
          isEditDesignOrder={isEditDesignOrder}
          headerStepBackRef={headerStepBackRef}
          onExitDesignOrderEditMode={handleExitDesignOrderEditMode}
          closeView={handleClose}
          renderCards={renderCards}
          onDataChange={handleDataChange} // Pass data change handler
          setIsEditDesignOrder={EditDesignOrder}

        />
      </Dialog>
    </>
  );
}
const MemoizedViewDesignOrder = React.memo(ViewDesignOrder);

export default React.memo(FullScreenDialogDesignOrder);

